export default __webpack_public_path__ + "static/chunks/ui-assets/pattern-grid-black/b02410ef1fb795cfcc7d6291826f11cc.webp";